import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import CartSidebar from './CartSidebar'
import Sidebar from './Sidebar'
import MobileNavbar from './MobileNavbar'

export default function Layout() {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const location = useLocation()

    // Check if current route is admin/owner (they have their own layout)
    const isAdminRoute = location.pathname.startsWith('/admin')
    const isOwnerRoute = location.pathname.startsWith('/owner')
    const isFullScreenRoute = location.pathname === '/shorts'

    // For admin and owner, don't show public layout
    if (isAdminRoute || isOwnerRoute || isFullScreenRoute) {
        return <Outlet />
    }

    return (
        <div className="min-h-screen flex">
            {/* Sidebar - Desktop */}
            <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

            {/* Main Content Area */}
            <div className={`flex-1 flex flex-col transition-all duration-300 w-full overflow-x-hidden overflow-y-visible ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-16'}`}>
                <Header sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

                <main className="flex-1 pt-16 pb-20 lg:pb-0 w-full overflow-x-hidden overflow-y-visible">
                    <Outlet />
                </main>

                <Footer />
            </div>

            {/* Cart Sidebar - Right */}
            <CartSidebar />

            {/* Mobile Bottom Navbar */}
            <MobileNavbar />
        </div>
    )
}
